/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Grid, Link, PageGridContainer, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/xdp';

const styles = {
  container: css`
    margin-bottom: var(--cds-spacing-300);
  `,
  privacyLink: css`
    color: inherit !important;
    text-decoration: underline !important;
  `,
};

const AiDisclaimerModule = () => {
  return (
    <PageGridContainer data-testid="block_layout" justifyContent="flex-start" id="ai-disclaimer" css={styles.container}>
      <Grid item xs={12}>
        <Typography2 variant="bodySecondary" component="p">
          <FormattedMessage
            message={_t(
              `¹ Some assignments in this course are AI-graded. For these assignments, your data will be used in accordance with {privacyNotice}.`
            )}
            privacyNotice={
              <Link href="/about/privacy" target="_blank" rel="noreferrer" variant="standard" css={styles.privacyLink}>
                {_t(`Coursera's Privacy Notice`)}
              </Link>
            }
          />
        </Typography2>
      </Grid>
    </PageGridContainer>
  );
};

export default AiDisclaimerModule;
